// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IHealthPlanTierStatsDto } from './IHealthPlanTierStatsDto';
import {
    IHealthPlanTierStatsDtoFromJSON,
    IHealthPlanTierStatsDtoFromJSONTyped,
    IHealthPlanTierStatsDtoToJSON,
    IHealthPlanTierStatsDtoToJSONTyped,
} from './IHealthPlanTierStatsDto';

/**
 * 
 * @export
 * @interface INotionalOverviewResponseDto
 */
export interface INotionalOverviewResponseDto {
    /**
     * 
     * @type {number}
     * @memberof INotionalOverviewResponseDto
     */
    active_enrollments?: number;
    /**
     * 
     * @type {number}
     * @memberof INotionalOverviewResponseDto
     */
    canceled_enrollments?: number;
    /**
     * 
     * @type {number}
     * @memberof INotionalOverviewResponseDto
     */
    total_elections?: number;
    /**
     * 
     * @type {number}
     * @memberof INotionalOverviewResponseDto
     */
    rollover_in?: number;
    /**
     * 
     * @type {number}
     * @memberof INotionalOverviewResponseDto
     */
    rollover_out?: number;
    /**
     * 
     * @type {number}
     * @memberof INotionalOverviewResponseDto
     */
    limited_use_count?: number;
    /**
     * 
     * @type {Array<IHealthPlanTierStatsDto>}
     * @memberof INotionalOverviewResponseDto
     */
    deductible_tracking?: Array<IHealthPlanTierStatsDto>;
    /**
     * 
     * @type {number}
     * @memberof INotionalOverviewResponseDto
     */
    plan_year_contributions?: number;
}

/**
 * Check if a given object implements the INotionalOverviewResponseDto interface.
 */
export function instanceOfINotionalOverviewResponseDto(value: object): value is INotionalOverviewResponseDto {
    return true;
}

export function INotionalOverviewResponseDtoFromJSON(json: any): INotionalOverviewResponseDto {
    return INotionalOverviewResponseDtoFromJSONTyped(json, false);
}

export function INotionalOverviewResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): INotionalOverviewResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'active_enrollments': json['active_enrollments'] == null ? undefined : json['active_enrollments'],
        'canceled_enrollments': json['canceled_enrollments'] == null ? undefined : json['canceled_enrollments'],
        'total_elections': json['total_elections'] == null ? undefined : json['total_elections'],
        'rollover_in': json['rollover_in'] == null ? undefined : json['rollover_in'],
        'rollover_out': json['rollover_out'] == null ? undefined : json['rollover_out'],
        'limited_use_count': json['limited_use_count'] == null ? undefined : json['limited_use_count'],
        'deductible_tracking': json['deductible_tracking'] == null ? undefined : ((json['deductible_tracking'] as Array<any>).map(IHealthPlanTierStatsDtoFromJSON)),
        'plan_year_contributions': json['plan_year_contributions'] == null ? undefined : json['plan_year_contributions'],
    };
}

export function INotionalOverviewResponseDtoToJSON(json: any): INotionalOverviewResponseDto {
    return INotionalOverviewResponseDtoToJSONTyped(json, false);
}

export function INotionalOverviewResponseDtoToJSONTyped(value?: INotionalOverviewResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active_enrollments': value['active_enrollments'],
        'canceled_enrollments': value['canceled_enrollments'],
        'total_elections': value['total_elections'],
        'rollover_in': value['rollover_in'],
        'rollover_out': value['rollover_out'],
        'limited_use_count': value['limited_use_count'],
        'deductible_tracking': value['deductible_tracking'] == null ? undefined : ((value['deductible_tracking'] as Array<any>).map(IHealthPlanTierStatsDtoToJSON)),
        'plan_year_contributions': value['plan_year_contributions'],
    };
}

